<template>
  <div :class="`collapsible ${opened ? 'is-open' : 'is-closed'}`">
    <div class="collapsible-header" @click="toggle(undefined)">
      <p class="collapsible-title super-title">
        {{ title }}
      </p>
    </div>

    <div v-if="opened" class="collapsible-content">
      <slot></slot>
    </div>

  </div>
</template>


<script>
export default {
  props: {
    title: String,
    open: Boolean // Приймаємо стан відкриття з SearchResults.vue
  },
  data: function () {
    return {
      opened: this.open
    };
  },
  watch: {
    open(val) {
      this.opened = val; // Оновлюємо стан
    }
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
      this.$emit("change", this.opened); // Надсилаємо подію наверх
    }
  }
};
</script>


<style lang="scss">
.collapsible {
  height: min-content;
  /* font-size: 12px; */
  grid-column: 1;
  margin: 0;
  padding: 16px 0 16px 0;
  border-bottom: 1px solid var(--col-lightblue);
  transition: background-color 0.5s ease-in-out;

  &.is-open {
     /* .search-box {
       max-height: 1000px;
       padding: 16px 0 0 0;
     } */

    .collapsible-header {
      &:before {
        transform: rotate(90deg);
      }
    }
  }

  &.is-closed {
    /* .search-box {
    //   overflow: hidden;
    // } */
    .info-card {
      display: none;
    }
  }

  &.is-simul {
    .collapsible-header {
      &:before {
        transform: rotate(90deg);
      }
    }
  }

  .collapsible-header {
    display: flex;
    flex-direction: row;
    position: relative;
    cursor: pointer;

    &:before,
    &:after {
      position: absolute;
      top: 5px;
      right: 28px;
      width: 1.5px;
      height: 1.2rem;
      content: "";
      background-color: var(--col-lightblue);
      transition: 0.3s ease-in-out;
    }

    &:after {
      transform: rotate(90deg);
    }

    .collapsible-title {
      transition: 0.5s;
      margin: 0;
      margin-right: 2.2em;
    }
  }
  .collapsible-content {
    display: block;
    overflow: hidden;
    transition: all 0.3s ease-out;
  }

  .collapsible.is-open .collapsible-content {
    height: auto;
    overflow: visible;
  }

  .collapsible.is-closed .collapsible-content {
    height: 0;
  }
}


.super-title {
  /* font-size: 1.2rem;
  letter-spacing: -0.03rem; */
  font-weight: 600;
}

</style>
